(function ($) {
  DJ.addBehavior('userPhoneSelectInit', '.cems-user-mobile-number-form', {
    attach: function () {
      const formWrapper = this;
      const select = formWrapper.querySelectorAll('select');
      const svgPath = DJ.getDrupalSettings().isSlicingEnvironment ? '../../assets/sprites/symbol/svg/sprite.symbol.svg' : '/themes/custom/cems_front/public/assets/sprites/symbol/svg/sprite.symbol.svg';

      jcf.replace(select, 'Select', {
        wrapNative: false
      });

      $('.jcf-select-opener', $(formWrapper)).append(`<span class="svg-icon"><svg><use xlink:href="${svgPath}#arrow_selector"></use></svg></span>`);
    }
  });
})(jQuery);
